module.exports = __webpack_public_path__ + "assets/e0ec247efbee03512feefc83c8166471.png";